<template>
	  <div id="header">
	  	  <div class="container-fluid">
	  	  	<navbar></navbar>
	  	  </div>
	  </div>
</template>

<script>
import Navbar from './navbar'
export default {
  name: 'cheader',
  components:{
  	Navbar
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/header/index.vue